import { useResourceContext } from "@/layouts/ResourceContext";
import { RESOURCE_TYPE_ADDONS } from "@/resources-def";
import { useTranslation } from "react-i18next";
import { useOne } from "@refinedev/core";
import { useEffect, useRef, useState } from "react";
import DualFormLayout from "../common/DualFormLayout";
import { Spin, Input, Descriptions } from 'antd';
import { useSearchParams } from "react-router-dom";
import { getAddonVersionSchema, HELM_LEFT_COLS, HELM_RIGHT_COLS, INFRA_LEFT_COLS, INFRA_RIGHT_COLS, MODULE_LEFT_COLS, MODULE_RIGHT_COLS } from "@/resources-def/addons-comp";

const { TextArea } = Input;

export const VersionDetailPanel = ({ resource="addon" }) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const { state, dispatch } = useResourceContext();
  const { selectedResources: [selectedAddon] } = state;
  const [searchParams] = useSearchParams();  
  const type = searchParams.get("type");
  const { data, isLoading, isError } = useOne({
    resource: resource, 
    id: selectedAddon?.id,
    meta: { version: selectedAddon?.version },
  });
  const columns = getAddonVersionSchema(type, false);

  return (
    <div>
      {isLoading ? <Spin size="large" /> : <DualFormLayout columns={columns} values={data} leftCol={ type === "module" ? MODULE_LEFT_COLS : type === "helm" ? HELM_LEFT_COLS : INFRA_LEFT_COLS} rightCol={ type === "module" ? MODULE_RIGHT_COLS : type === "helm" ? HELM_RIGHT_COLS : INFRA_RIGHT_COLS}/>}
    </div>
  );
};
